<template>
  <div class="container full-width"> 
        <!-- Start Modal -->
    <!-- Modal -->
    <div class="modal fade" id="errModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <div class="modal-title" style="display: block;">
                <div class="arrow" style="margin-left: 0;"></div>
                <div class="h2-arrow" style="padding: 0;">
                  VOTRE MESSAGE COMPORTE<br/>LES ERREURS SUIVANTES :
                </div>
            </div>
          </div>
          <div id="error-modal-content" class="modal-body">
            <ul>
              <!-- <li v-for="(err, index) in errArray" class="error-list">
                {{err}}
              </li> -->
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <!-- End Modal -->

    <!-- Header Start -->
    <app-header></app-header>
    <!-- Header End -->

    <!-- div oblique -->
    <side-info :template="name" v-bind:style="[mainPaddingTop]" ref="sideInfo"></side-info>

    <div class="main" v-bind:style="mainPaddingTop">
      <div class="fil-ariane">
          <router-link to="/app/home" class="parent-items">
            Mon espace >
          </router-link>
          <router-link to="/app/creer-un-message" class="parent-items">
            Ajouter un nouveau message >
          </router-link>
          <router-link to="/app/gerer-diffusion" class="parent-items">
            Gérer ma diffusion
          </router-link>
      </div>
      <h1 class="page-title">Créer mon message</h1>
      <!--  -->
      <div class="main-content">
        <div class="info-box-main" style="margin-top: calc(85vh / (949 / 21));">
          <svg class="info-box-icon-main" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
          <div class="info-text-main">
            Créez une nouvelle communication en choisissant un modèle,<br/>un titre et un texte pour votre annonce.
          </div>
        </div>
        <div class="editor-holder col-md-12 col-lg-12">
          <div v-for="(template, index) in templates" class="vignette-holder">
            <img class="vignette" :src="template.thumbnail" v-on:click="pickTemplate(template.name)" v-bind:data-template-index="template.id"/>
            <div class="template-label">{{template.label}}</div>
          </div>
          
          <div id="visualisation-holder-reduced"></div>
          <p class="explication-texte">*Afin de modifier le style de votre texte, selectionner le texte en double cliquant dessus</p>
        </div>        
        <button id="set-message-compo" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 15));">
          VALIDER
        </button>
        <div class="hr"></div>
        <!-- ////////////////////////////////////////// -->
      </div>
    </div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
    <!-- Button trigger modal -->
    <button id="modalButton" type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#errModal" style="visibility: hidden;">
      Launch modal
    </button>
    <!-- <div id="tempHolder" style="visibility: hidden;"></div> -->
  </div>
</template>

<script>
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
  import setPaddingTop from '@/common/lib/setPaddingTop'
  import Header from '@/components/Header'
  import SideInfo from '@/components/SideInfo'
  import Footer from '@/components/Footer'
  export default {
    data () {
      return {
        name: 'CreerUnMessage',
        user: AppModules.getUser(),
        userProps: null,
        templates: [],
        mainPaddingTop: {
          paddingTop: '0'
        },
        sideInfoBackground: {
          backgroundImage: 'none'
        },
        inputTitle: 'Votre Titre',
        store: AppModules.Store,
        definitions: AppModules.MessageDefinitions[process.env.APP_NAME],
        selectedTemplate: (AppModules.Store.get('pickedTemplate')) ? AppModules.MessageDefinitions[process.env.APP_NAME].templates[parseInt(AppModules.Store.get('pickedTemplate'))] : AppModules.MessageDefinitions[process.env.APP_NAME].templates[0]
      }
    },
    components: {
      'app-header': Header,
      'side-info': SideInfo,
      'app-footer': Footer
    },
    mounted: function () {
      return this.user.getProperties((err, userProps) => {
        if (err) {
          console.error(err)
        }

        this.userProps = userProps

        this.$commercantTrade = this.$tradeSwitch(userProps)

        this.adjustPaddingTop()

        this.templates = this.definitions.templates.reduce((prev, curr, idx, arr) => {
          if (idx === 0) {
            return prev
          }

          const background = curr.fullStyle.backgroundStyle.backgroundImage[this.$commercantTrade] || null
          const template = {
            id: curr.id,
            name: curr.name,
            thumbnail: curr.thumbnails[this.$commercantTrade],
            background: background
          }
          prev.push(template)
          return prev
        }, [])

        console.debug('============================================> process.env.APP_NAME', process.env.APP_NAME)
        console.debug('commercant trade', this.$commercantTrade)
        console.debug('this.definitions.templates', this.definitions.templates)
        console.debug('this.templates', this.templates)
        console.debug('============================================>')

        window.removeEventListener('resize', this.adjustPaddingTop, false)
        window.addEventListener('resize', this.adjustPaddingTop, false)

        window.tinymce.remove()
        const target = document.querySelector('#visualisation-holder-reduced')

        AppModules.clearMessages()

        AppModules.MessageDefinitions[process.env.APP_NAME].templates.forEach(messageTemplate => {
          console.debug('=======> CreerUnMessage getMessage', messageTemplate, this.$commercantTrade, target)
          let message = AppModules.getMessage(messageTemplate, this.$commercantTrade, target)
          message.init()
        })

        this.showSelected(this.selectedTemplate.id)
      })
    },
    methods: {
      adjustPaddingTop: function () {
        return setPaddingTop((err, paddingTop) => {
          if (err) {
            console.error(err)
          }
          this.mainPaddingTop.paddingTop = paddingTop + 'px'
          return this.user.getProperties((err, userProps) => {
            if (err) {
              console.error(err)
            }
          })
        })
      },
      showSelected: function (selectedTemplateId) {
        const vignettes = document.querySelectorAll('.vignette')
        Array.prototype.forEach.call(vignettes, (item) => {
          if (parseInt(selectedTemplateId) === parseInt(item.dataset.templateIndex)) {
            item.classList.add('vignette-selected')
          } else {
            item.classList.remove('vignette-selected')
          }
        })
        //
        try {
          const visualisations = document.querySelectorAll('.visualisation')
          Array.prototype.forEach.call(visualisations, function (item) {
            if (parseInt(selectedTemplateId) === parseInt(item.dataset.templateIndex)) {
              item.classList.add('template-active')
            } else {
              item.classList.remove('template-active')
            }
          })
        } catch (err) {
          console.error(err)
        }
      },
      pickTemplate: function (templateName) {
        var isTheOne = function (template) {
          return templateName === template.name
        }
        this.selectedTemplate = this.definitions.templates.find(isTheOne)
        //
        if (this.selectedTemplate) {
          this.showSelected(this.selectedTemplate.id)
          this.store.set('pickedTemplate', this.selectedTemplate.id)
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (max-width: 1366px) {
    
    .vignette-holder {
      /*margin-bottom: 25px;*/
      /*width: 180px;*/
      width: calc(85vh / (637 / 165));
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      /*margin: 30px 15px;*/
      margin: calc(85vh / (637 / 15)) calc(85vh / (637 / 8));
    }

    .vignette {
      width: calc(85vh / (637 / 165));
      border: 1px solid var(--primary-color);
      box-sizing: border-box;
      border-radius: 10px;
    }

    .template-label {
      font-family: 'Open Sans', Arial;
      color: var(--primary-color);
      font-weight: 400;
      font-size: calc(85vh / (637 / 16));
      display: block;
      margin-top: calc(85vh / (637 / 7));
    }

  }

  @media (min-width: 1367px) {

    .vignette-holder {
      /*margin-bottom: 25px;*/
      width: 180px;
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      margin: 20px 15px;
    }

    .vignette {
      width: 180px;
      /* border: 1px solid var(--primary-color); */
      border: 1px solid var(--grey-eighth-color);
      box-sizing: border-box;
      border-radius: 10px;
    }

    .template-label {
      font-family: 'Open Sans', Arial;
      color: var(--grey-eighth-color);
      font-weight: 400;
      font-size: 16px;
      display: block;
      margin-top: 7px;
    }

  }

  p {
    text-align: justify;
    padding-bottom: 25px;
  }

  .vignette-selected {
    border: 10px solid var(--primary-color);
    box-sizing: border-box;
  }

  #visualisation-holder-reduced {
    /*position: absolute;*/
    position: relative;
    width: 100%;
    width: 512px;
    height: 334px;
    margin: 0 auto;
    /*overflow: hidden;*/
  }

  .fade-enter-active, .fade-leave-active {
    /*transition: <property> <duration> <timing-function> <delay>;*/
    transition: all 0.8s ease;
    visibility: visible;
    opacity: 1;
    position: absolute;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    visibility: hidden;
  }

  #compose-message-button {
    cursor: pointer;
  }

</style>




// WEBPACK FOOTER //
// CreerUnMessage.vue?2b3f5bba